import React, { useEffect, useRef, useState } from "react";

const AdUnitWrapper = ({ clientId, slotId }) => {
  const adRef = useRef(null);
  const [showAd, setShowAd] = useState(false);
  const isProd = typeof window !== "undefined" && !window.location.hostname.includes("localhost");

  useEffect(() => {
    if (!isProd || !adRef.current) return;

    // Push ad
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch (e) {
      console.error("AdSense error:", e);
    }

    // Check if ad is loaded
    const checkAd = setInterval(() => {
      if (adRef.current && adRef.current.innerHTML.trim() !== "") {
        setShowAd(true);
        clearInterval(checkAd);
      }
    }, 500);

    return () => clearInterval(checkAd);
  }, [isProd]);

  if (!isProd || !showAd) return null; // Don't render div if no ad

  return (
    <div style={{ display: "flex", justifyContent: "center", margin: "1.5rem 0" }}>
      <ins
        className="adsbygoogle"
        style={{ display: "block", width: "100%" }}
        data-ad-client={clientId}
        data-ad-slot={slotId}
        data-ad-format="auto"
        data-full-width-responsive="true"
        ref={adRef}
      ></ins>
    </div>
  );
};

export default AdUnitWrapper;